import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
import type { ActionJob, LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

export const getBreakerLocalActions = (
	action: ActionJob,
	params: { id: number },
): LocalControlOptions[] => {
	const $format = get(format);
	return [
		{
			title: $format('label_output_circuit_breaker', {
				default: 'Circuit breaker',
			}),
			value: 'cb.set',
			attr: {
				output: true,
			},
			params: {
				id: params.id,
				output: action.params?.output || false,
			},
		},
	];
};
